/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import { bool } from 'prop-types';

import { Placeholder } from '@thd-olt-component-react/core-ui';

import { ReservationContext } from '../../context/reservation-context';
import { ReservationLookupApiContext } from '../../context/ReservationLookupApiContext';
import {
  getDateFromUTC,
  getTimeFromUTC,
  getFormattedDateFromString,
  getFormattedTimeFromString
} from '../../utils/mapper';

import './current-times.scss';

export const CurrentTimes = ({ compare }) => {
  const { data: reservationApiData, loading } = useContext(ReservationLookupApiContext);
  const [{
    reservation: {
      pickupDate,
      pickupTime,
      dropoffDate,
      dropoffTime
    }
  }] = useContext(ReservationContext);

  const { pickup_time: apiPickupTime, return_time: apiReturnTime } = reservationApiData || {};

  return (
    <div className="current-time">
      <div className="current-time-container">
        <div className="container-title">
          Pickup Date and Time
        </div>
        <div className="current-selection">
          <div className="date">
            <div className="current-selection-time">
              {
                loading ? <Placeholder type="rect" height="20px" width="120px" /> : (
                  compare ? getFormattedDateFromString(pickupDate) : getDateFromUTC(apiPickupTime)
                )
              }
            </div>
          </div>
          <div className="time">
            {
              loading ? <Placeholder type="rect" height="20px" width="60px" /> : (
                compare ? getFormattedTimeFromString(pickupTime) : getTimeFromUTC(apiPickupTime)
              )
            }
          </div>
        </div>
        {compare && (
          <div className="previous-selection">
            <div className="date">
              Original: <div className="previous-selection-time strikethrough">{getDateFromUTC(apiPickupTime)}</div>
            </div>
            <div className="time strikethrough">
              {getTimeFromUTC(apiPickupTime)}
            </div>
          </div>
        )}
      </div>
      <div className="current-time-container">
        <div className="container-title">
          Dropoff Date and Time
        </div>
        <div className="current-selection">
          <div className="date">
            <div className="current-selection-time">
              {
                loading ? <Placeholder type="rect" height="20px" width="120px" /> : (
                  compare ? getFormattedDateFromString(dropoffDate) : getDateFromUTC(apiReturnTime)
                )
              }
            </div>
          </div>
          <div className="time">
            {
              loading ? <Placeholder type="rect" height="20px" width="60px" /> : (
                compare ? getFormattedTimeFromString(dropoffTime) : getTimeFromUTC(apiReturnTime)
              )
            }
          </div>
        </div>
        {compare && (
          <div className="previous-selection">
            <div className="date">
              Original: <div className="previous-selection-time strikethrough">{getDateFromUTC(apiReturnTime)}</div>
            </div>
            <div className="time strikethrough">
              {getTimeFromUTC(apiReturnTime)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

CurrentTimes.defaultProps = {
  compare: false
};

CurrentTimes.propTypes = {
  compare: bool
};
